<template>
  <el-dialog
    class="dialog-container"
    :title="title"
    :visible.sync="dialogVisible"
    width="800px"
    append-to-body
    destroy-on-close
  >
    <el-form
      ref="form"
      :model="form"
      :rules="formRules"
      label-width="155px"
    >
      <!-- 基本信息 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/basicIcon.png" alt="" />
          <span>基本信息</span>
        </div>
        <!-- 故障发生日期 -->
        <el-form-item label="故障发生日期" prop="happenDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.happenDate"
            placeholder="请选择故障发生日期"
          ></el-date-picker>
        </el-form-item>
        <!-- 故障发生地点 -->
        <el-form-item label="故障发生地点" prop="happenPlace">
          <el-input
            v-model="form.happenPlace"
            maxlength="200"
            placeholder="请输入故障发生地点"
          ></el-input>
        </el-form-item>
        <!-- 报修日期 -->
        <el-form-item label="报修日期" prop="repairDate">
          <el-date-picker
            type="date"
            value-format="yyyy-MM-dd"
            v-model="form.repairDate"
            placeholder="请选择报修日期"
          />
        </el-form-item>
        <!-- 严重程度 -->
        <el-form-item label="严重程度" prop="severityLevel">
          <el-select filterable clearable v-model="form.severityLevel" placeholder="请选择严重程度">
            <el-option
              v-for="(item, index) in severityData"
              :key="index"
              :label="item.label"
              :value="item.code"
            >
              <el-tooltip placement="right" effect="light">
                <div
                  slot="content"
                  class="severityTips"
                  v-html="item.desc"
                ></div>
                <span>{{ item.label }}</span>
              </el-tooltip>
            </el-option>
          </el-select>
        </el-form-item>
        <!-- 客户诉求 -->
        <el-form-item label="客户诉求" prop="customerDemand">
          <el-input
            v-model="form.customerDemand"
            type="textarea"
            placeholder="请输入客户诉求"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 是否重点问题 -->
        <el-form-item label="是否重点问题" prop="importantType" required>
          <el-radio-group v-model="form.importantType">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 重点问题描述 -->
        <el-form-item
          v-if="form.importantType === 1"
          label="重点问题描述"
          prop="importantDescribe"
        >
          <el-input
            v-model="form.importantDescribe"
            placeholder="请输入重点问题描述"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 是否有维修措施 -->
        <el-form-item label="是否有维修措施" prop="serviceMeasure" required>
          <el-radio-group v-model="form.serviceMeasure">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 市场维修措施 -->
        <el-form-item
          label="市场维修措施"
          prop="marketService"
          v-if="form.serviceMeasure == 1"
        >
          <el-input
            v-model="form.marketService"
            placeholder="请输入市场维修措施"
            type="textarea"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          ></el-input>
        </el-form-item>
        <!-- 零部件类别 -->
        <el-form-item label="零部件类别" prop="componentCategory"  placeholder="请选择零部件类别">
          <el-select v-model="form.componentCategory" filterable clearable>
            <el-option
              v-for="(item, index) in componentCategoryList"
              :key="index"
              :label="item[componentCategoryName.get('zh')]"
              :value="item.code"
            >
            </el-option>
          </el-select>
        </el-form-item>

        <!-- 零部件批次信息 -->
        <el-form-item label="零部件批次信息" prop="componentBatchs">
          <el-input
            v-model="form.componentBatchs"
            placeholder="请输入零部件批次信息"
          ></el-input>
        </el-form-item>
        <!-- 发动机型号 -->
        <el-form-item
          label="发动机型号"
          prop="engineModel"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineModel"
            placeholder="请输入发动机型号"
          ></el-input>
        </el-form-item>
        <!-- 发动机号 -->
        <el-form-item
          label="发动机号"
          prop="engineNumber"
          v-if="form.componentCategory == '1' || form.componentCategory == '2'"
        >
          <el-input
            v-model="form.engineNumber"
            placeholder="请输入发动机号"
          ></el-input>
        </el-form-item>
        <!-- 动力电池号 -->
        <el-form-item
          label="动力电池号"
          prop="batteryNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.batteryNumber"
            placeholder="请输入动力电池号"
          ></el-input>
        </el-form-item>
        <!-- 电机号 -->
        <el-form-item
          label="电机号"
          prop="motorNumber"
          v-if="form.componentCategory == '8'"
        >
          <el-input
            v-model="form.motorNumber"
            placeholder="请输入电机号"
          ></el-input>
        </el-form-item>
        <!-- 订单号 -->
        <el-form-item label="订单号" prop="orderNum">
          <el-input
            v-model="form.orderNum"
            placeholder="请输入订单号"
          ></el-input>
        </el-form-item>

        <!-- 订单数量 -->
        <el-form-item label="订单数量" prop="carTotal">
          <el-input v-model="form.carTotal" placeholder="请输入订单数量" />
        </el-form-item>
        <!-- 故障数量 -->
        <el-form-item label="故障数量" prop="faultNumber">
          <el-input-number
            :controls="false"
            :precision="0"
            v-model="form.faultNumber"
            placeholder="请输入故障数量"
          >
          </el-input-number>
        </el-form-item>

        <!-- 疑似/祸首件代码 -->
        <el-form-item label="疑似/祸首件代码" prop="suspectPartNumber">
          <div class="searchFlex">
            <el-input
              v-model="form.suspectPartNumber"
              placeholder="请输入疑似/祸首件代码"
            ></el-input>
            <el-button
              class="primary-btn"
              type="primary"
              @click="handlePartSearch"
            >查询</el-button>
          </div>
        </el-form-item>
        <!-- 疑似/祸首件名称 -->
        <el-form-item label="疑似/祸首件名称" prop="suspectPartName">
          <el-input
            v-model="form.suspectPartName"
            placeholder="请输入疑似/祸首件名称"
          ></el-input>
        </el-form-item>
        <!-- 供应商代码/名称 -->
        <!-- <el-form-item label="供应商代码/名称" prop="supplierInfo">
          <el-input v-model="form.supplierInfo" placeholder="请输入供应商代码/名称"></el-input>
        </el-form-item> -->
      </div>
      <!-- 问题描述 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/wtmsIcon.png" alt="" />
          问题描述
        </div>
        <!-- 故障描述 -->
        <el-form-item label="故障现象描述" prop="questionContent">
          <el-input
            v-model="form.questionContent"
            type="textarea"
            placeholder="请输入故障现象描述"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <!-- 重复性 -->
        <el-form-item label="重复性" prop="repeatability">
          <el-radio-group v-model="form.repeatability">
            <el-radio :label="0">一直存在</el-radio>
            <el-radio :label="1">偶发</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 有无超载 -->
        <el-form-item label="有无超载" prop="overload">
          <el-radio-group v-model="form.overload">
            <el-radio :label="0">有</el-radio>
            <el-radio :label="1">无</el-radio>
          </el-radio-group>
        </el-form-item>
        <!-- 行驶工况 -->
        <el-form-item label="行驶工况" prop="drivingCondition">
          <el-input
            v-model="form.drivingCondition"
            placeholder="请输入行驶工况"
          ></el-input>
        </el-form-item>
        <!-- 行驶路况 -->
        <el-form-item label="行驶路况" prop="roadCondition">
          <el-input
            v-model="form.roadCondition"
            placeholder="请输入行驶路况"
          ></el-input>
        </el-form-item>
        <!-- 天气情况 -->
        <el-form-item label="天气情况" prop="weatherCondition">
          <el-input
            v-model="form.weatherCondition"
            placeholder="请输入天气情况"
          ></el-input>
        </el-form-item>
        <!-- 加装情况 -->
        <el-form-item label="加装情况" prop="modificationStatus">
          <el-input
            v-model="form.modificationStatus"
            placeholder="请输入加装情况"
          ></el-input>
        </el-form-item>

        <!-- 附件 -->
        <!-- <el-form-item label="附件" prop="faultCommonFiles">
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCommonFiles"
            :httpRequest="action"
          />
        </el-form-item> -->
      </div>
      <!-- 图片和视频 -->
      <div>
        <div class="titleTips">
          <img src="@/assets/image/ImgIcon.png" alt="" />
          图片和视频
        </div>
        <fileUploadTips></fileUploadTips>
        <!-- 是否有故障视频/图片 -->
        <el-form-item label="是否有故障视频/图片" prop="faultVideo" required>
          <el-radio-group v-model="form.faultVideo">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="附件"
          prop="faultVideoFiles"
          v-if="form.faultVideo == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultVideoFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有故障代码 -->
        <el-form-item label="是否有故障代码" prop="faultCode" required>
          <el-radio-group v-model="form.faultCode">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="faultCodeRemark"
          v-if="form.faultCode == 1"
        >
          <el-input
            v-model="form.faultCodeRemark"
            type="textarea"
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="附件"
          prop="faultCodeFiles"
          v-if="form.faultCode == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.faultCodeFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
        <!-- 是否有其他说明 -->
        <el-form-item label="是否有其他说明" prop="otherInstructions" required>
          <el-radio-group v-model="form.otherInstructions">
            <el-radio :label="1">是</el-radio>
            <el-radio :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item
          label="备注"
          prop="otherRemark"
          v-if="form.otherInstructions == 1"
        >
          <el-input
            v-model="form.otherRemark"
            type="textarea"
            placeholder="请输入备注"
            :autosize="{ minRows: 2, maxRows: 4 }"
            maxlength="500"
            show-word-limit
          />
        </el-form-item>
        <el-form-item
          label="附件"
          prop="otherFiles"
          v-if="form.otherInstructions == 1"
        >
          <drag-upload
            ref="uploadFile"
            :accessoryList.sync="form.otherFiles"
            :tipStatus="false"
            :httpRequest="action"
          />
        </el-form-item>
      </div>
      <div v-if="form.componentCategory == '1'">
        <!-- 发动机保养记录 -->
        <div class="titleTips">
          <img src="@/assets/image/engineRecords.png" alt="" />
          发动机保养记录
        </div>
        <div class="maintenance-records">
          <div class="record-header">
            <el-button
              type="primary"
              @click="addEngineRecord"
              class="add-record-btn"
              icon="el-icon-plus"
              >添加发动机保养记录</el-button
            >
          </div>
          <div>
            <div
              v-for="(record, index) in form.engineRecordList"
              :key="'engine-' + index"
              class="record-item"
            >
              <div class="record-form">
                <div class="remove-record">
                  <el-button
                    type="text"
                    @click="removeEngineRecord(index)"
                    class="remove-record-btn"
                    icon="el-icon-delete"
                  >
                    删除
                  </el-button>
                </div>
                <el-form-item
                  label="保养时间"
                  :prop="`engineRecordList.${index}.time`"
                  class="record-form-item"
                  labe-width="110px"
                  :rules="[
                    {
                      required: true,
                      message: '保养时间不能为空',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="record.time"
                    placeholder="请选择保养时间"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label="保养里程"
                  :prop="`engineRecordList.${index}.mileage`"
                  class="record-form-item"
                  labe-width="110px"
                  :rules="[
                    {
                      required: true,
                      message: '保养里程不能为空',
                      trigger: 'blur',
                    },
                    {
                      pattern: /^[1-9]\d*$/,
                      message: '请输入有效的正整数',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input-number
                    class="number-input"
                    v-model="record.mileage"
                    :controls="false"
                    :precision="0"
                    placeholder="请输入里程"
                  >
                  </el-input-number>
                  <div class="number-input-append">km</div>
                </el-form-item>
                <el-form-item
                  label="保养内容"
                  :prop="`engineRecordList.${index}.content`"
                  class="record-form-item"
                  labe-width="110px"
                >
                  <el-input
                    v-model="record.content"
                    type="textarea"
                    placeholder="请输入保养内容"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    maxlength="500"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="附件"
                  labe-width="110px"
                  :prop="`engineRecordList.${index}.photos`"
                  class="record-form-item photos-item"
                  :rules="[
                    {
                      required: true,
                      message: '附件不能为空',
                      trigger: 'change',
                    },
                  ]"
                >
                  <drag-upload
                    ref="uploadFile"
                    :accessoryList.sync="record.photos"
                    :httpRequest="action"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div v-if="form.componentCategory == '2'">
        <!-- 变速器保养记录 -->
        <div class="titleTips">
          <img src="@/assets/image/gearbox.png" alt="" />
          变速器保养记录
        </div>
        <div class="maintenance-records">
          <div class="record-header">
            <el-button
              type="primary"
              @click="addTransmissionRecord"
              class="add-record-btn"
              icon="el-icon-plus"
            >
              添加变速器保养记录
            </el-button>
          </div>
          <div>
            <div
              v-for="(record, index) in form.transmissionRecordList"
              :key="'transmission-' + index"
              class="record-item"
            >
              <div class="record-form">
                <div class="remove-record">
                  <el-button
                    type="text"
                    @click="removeTransmissionRecord(index)"
                    class="remove-record-btn"
                    icon="el-icon-delete"
                  >
                    删除
                  </el-button>
                </div>
                <el-form-item
                  label="保养时间"
                  :prop="`transmissionRecordList.${index}.time`"
                  class="record-form-item"
                  labe-width="110px"
                  :rules="[
                    {
                      required: true,
                      message: '保养时间不能为空',
                      trigger: 'change',
                    },
                  ]"
                >
                  <el-date-picker
                    type="date"
                    value-format="yyyy-MM-dd"
                    v-model="record.time"
                    placeholder="请选择保养时间"
                  >
                  </el-date-picker>
                </el-form-item>
                <el-form-item
                  label="保养里程"
                  labe-width="110px"
                  :prop="`transmissionRecordList.${index}.mileage`"
                  class="record-form-item"
                  :rules="[
                    {
                      required: true,
                      message: '保养里程不能为空',
                      trigger: 'blur',
                    },
                  ]"
                >
                  <el-input-number
                    class="number-input"
                    v-model="record.mileage"
                    :controls="false"
                    :precision="0"
                    placeholder="请输入里程"
                  >
                  </el-input-number>
                  <div class="number-input-append">km</div>
                </el-form-item>
                <el-form-item
                  label="保养内容"
                  :prop="`transmissionRecordList.${index}.content`"
                  class="record-form-item content-item"
                  labe-width="110px"
                >
                  <el-input
                    v-model="record.content"
                    type="textarea"
                    placeholder="请输入保养内容"
                    :autosize="{ minRows: 2, maxRows: 4 }"
                    maxlength="500"
                    show-word-limit
                  ></el-input>
                </el-form-item>
                <el-form-item
                  label="附件"
                  labe-width="110px"
                  :prop="`transmissionRecordList.${index}.photos`"
                  class="record-form-item photos-item"
                  :rules="[
                    {
                      required: true,
                      message: '附件不能为空',
                      trigger: 'change',
                    },
                  ]"
                >
                  <drag-upload
                    ref="uploadFile"
                    :accessoryList.sync="record.photos"
                    :httpRequest="action"
                  />
                </el-form-item>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-form>
    <div slot="footer" class="dialog-footer-button">
      <el-button
        class="primary-btn"
        type="primary"
        @click="handleSave"
      >
        提交
      </el-button>
      <el-button
        class="primary-btn"
        type="primary"
        plain
        @click="dialogVisible = false"
        >取消</el-button
      >
    </div>
  </el-dialog>
</template>

<script>
import {
  afterProblemEditApi,
  getVehicleAmountByOrderNumber,
} from "@/api/feedback";
import componentConfig from "@/mixins/componentConfig";
// import uploadFileNew from "@/components/uploadFileNew.vue";
import fileUploadTips from "@/components/fileUpload/fileUploadTips.vue";
import { getStorage } from "@/util/localStor";

// src\
export default {
  components: { fileUploadTips },
  mixins: [componentConfig],
  props: {},
  data() {
    return {
      action: "/manage/saleChannelController/upload/file",
      title: "", // 弹窗标题
      dialogVisible: false, // 弹窗显示
      form: this.getForm(), // 表单数据
      operate: "", // 操作方式：edit-直接编辑
    };
  },
  computed: {
    // 表单验证规则
    formRules() {
      // 公共规则配置
      const commonRule = {
        required: true,
        trigger: ["change", "blur"],
      };
      // 文件类字段的通用规则
      const createRule = (fieldName) => [
        { ...commonRule, message: `${fieldName}不能为空` },
      ];
      return {
        happenDate: createRule("故障发生日期"),
        repairDate: createRule("报修日期"),
        severityLevel: createRule("严重程度"),
        importantDescribe: createRule("重点问题描述"),
        marketService: createRule("市场维修措施"),
        componentCategory: createRule("零部件类别"),
        engineModel: createRule("发动机型号"),
        engineNumber: createRule("发动机号"),
        orderNum: createRule("订单号不能为空"),
        carTotal: createRule("订单数量不能为空"),
        faultNumber: createRule("故障数量"),
        customerDemand: createRule("客户诉求"),
        questionContent: createRule("故障现象描述"),
        repeatability: createRule("重复性"),
        faultVideoFiles: createRule("是否有故障视频/图片附件"),
        faultCodeRemark: createRule("是否有故障代码备注"),
        otherRemark: createRule("是否有其他说明备注"),
      };
    },
  },
  created() {},
  methods: {
    // 解析保养记录数据，兼容旧格式
    parseMaintenanceRecords(records) {
      if (!records || !Array.isArray(records)) {
        return [];
      }
      // 如果是新格式（对象数组），直接返回
      if (
        records.length > 0 &&
        typeof records[0] === "object" &&
        records[0].time !== undefined
      ) {
        return records;
      }
      // 如果是旧格式（图片数组），转换为新格式
      if (records.length > 0 && typeof records[0] === "string") {
        return [
          {
            time: "",
            mileage: undefined,
            content: "",
            photos: records,
          },
        ];
      }
      return records;
    },

    // 添加发动机保养记录
    addEngineRecord() {
      this.form.engineRecordList.push({
        time: "",
        mileage: undefined,
        content: "",
        photos: [],
      });
    },

    // 删除发动机保养记录
    removeEngineRecord(index) {
      this.form.engineRecordList.splice(index, 1);
    },

    // 添加变速器保养记录
    addTransmissionRecord() {
      this.form.transmissionRecordList.push({
        time: "",
        mileage: undefined,
        content: "",
        photos: [],
      });
    },

    // 删除变速器保养记录
    removeTransmissionRecord(index) {
      this.form.transmissionRecordList.splice(index, 1);
    },

    async handleOrder() {
      if (this.form.orderNum) {
        const res = await getVehicleAmountByOrderNumber(this.form.orderNum);
        if (res.status == 0) {
          this.form.carTotal = res.data || "0";
        }
      }
    },
    // 初始化
    async init(title, data = {}, orderNum, type) {
      this.title = title;
      this.operate = type || "";
      this.dialogVisible = true;
      // data.orderNumber = ;
      this.form = this.getForm(data, orderNum);
      this.$nextTick(() => {
        this.$refs.form.clearValidate();
      });
    },
    // 获取疑似/祸首件名称
    handlePartSearch() {
      this.getCheckPartInfo(this);
    },
    getFileInfo(fileItem) {
      const value = fileItem;
      if (Array.isArray(value)) return value;
      if (typeof value === "string") {
        try {
          return JSON.parse(value) || [];
        } catch {
          return [];
        }
      }
      // 其他情况（undefined/null）→ 返回空数组
      return [];
    },
    // 格式化保养记录数据
    formatMaintenanceRecords(records) {
      if (Array.isArray(records)) {
        // 如果是新格式的数组对象
        return records.map((record) => ({
          time: record.time || "",
          mileage: record.mileage || undefined,
          content: record.content || "",
          photos: record.photos || [],
        }));
      } else {
        // 如果是旧格式的图片数组，转换为新格式
        return records
          ? [{ time: "", mileage: undefined, content: "", photos: records }]
          : [];
      }
    },
    // 获取表单对象
    getForm(data = {}) {
      const customer = getStorage("qualityData");
      return {
        countryDataId: data.countryDataId || customer.countryDataId,
        carType: data.carType || customer.carType,
        happenDate: data.happenDate || "",
        happenPlace: data.happenPlace || "",
        repairDate: data.repairDate || "",
        severityLevel: data.severityLevel || "",
        importantType: data.importantType ?? 1,
        importantDescribe: data.importantDescribe || "",
        serviceMeasure: data.serviceMeasure ?? 0,
        marketService: data.marketService || "",
        componentCategory: Number(data.componentCategory) || "",
        componentBatchs: data.componentBatchs || "",
        engineModel: data.engineModel || "",
        engineNumber: data.engineNumber || "",
        batteryNumber: data.batteryNumber || "",
        motorNumber: data.motorNumber || "",
        orderNum: data.orderNum || "",
        carTotal: data.carTotal || "",
        faultNumber: data.faultNumber || undefined,
        suspectPartName: data.suspectPartName || "",
        suspectPartNumber: data.suspectPartNumber || "",
        customerDemand: data.customerDemand || "",
        supplierInfo: data.supplierInfo || "",
        questionContent: data.questionContent || "",
        repeatability: data.repeatability || 0,
        overload: data.overload || 1,
        drivingCondition: data.drivingCondition || "",
        roadCondition: data.roadCondition || "",
        weatherCondition: data.weatherCondition || "",
        modificationStatus: data.modificationStatus || "",
        faultCommonFiles: this.getFileInfo(data.faultCommonFiles),
        faultVideo: data.faultVideo ?? 1,
        faultVideoFiles: this.getFileInfo(data.faultVideoFiles),
        faultCode: data.faultCode ?? 1,
        faultCodeRemark: data.faultCodeRemark || "",
        faultCodeFiles: this.getFileInfo(data.faultCodeFiles),
        otherInstructions: data.otherInstructions ?? 1,
        otherRemark: data.otherRemark || "",
        otherFiles: this.getFileInfo(data.otherFiles),

        feedbackFormId: data.feedbackFormId || "",
        questionId: data.questionId || "",
        questionNum: data.questionNum || "",

        submit: data.status === 3 ? true : false,

        engineRecordList: data.maintenanceRecordInfo
          ? this.formatMaintenanceRecords(
              data.maintenanceRecordInfo.engineRecordList || []
            )
          : [],
        transmissionRecordList: data.maintenanceRecord
          ? this.formatMaintenanceRecords(
              data.maintenanceRecordInfo.transmissionRecordList || []
            )
          : [],
        maintenanceRecordInfo: data.maintenanceRecordInfo,
        maintenanceRecord: data.maintenanceRecord,
      };
    },
    // 保存
    handleSave() {
      this.$refs.form.validate(async (valid, object) => {
        if (this.getRequiredValid(valid, object)){
          return
        }
        const submitData = this.getFeedbackDetail();
        if (this.operate === "edit") {
          try {
            const res = await afterProblemEditApi({ data: submitData });
            if (res.status == 0) {
              this.dialogVisible = false;
              this.$DonMessage.success("提交成功");
              this.$emit("success");
            } else {
              this.$DonMessage.error(res.message);
            }
          } catch (error) {
            console.error(error);
          }
        } else {
          this.dialogVisible = false;
          this.$emit("success", submitData);
        }
      });
    },

    // // 校验保养记录
    // validateMaintenanceRecords() {
    //   // 校验发动机保养记录
    //   if (this.form.engineRecordList && this.form.engineRecordList.length > 0) {
    //     for (let i = 0; i < this.form.engineRecordList.length; i++) {
    //       const record = this.form.engineRecordList[i];
    //       if (!record.time) {
    //         return {
    //           valid: false,
    //           message: `第${i + 1}条发动机保养记录缺少保养时间`,
    //         };
    //       }
    //       if (
    //         record.mileage === "" ||
    //         record.mileage === null ||
    //         record.mileage === undefined
    //       ) {
    //         return {
    //           valid: false,
    //           message: `第${i + 1}条发动机保养记录缺少保养里程`,
    //         };
    //       }
    //       if (!record.photos || record.photos.length === 0) {
    //         return {
    //           valid: false,
    //           message: `第${i + 1}条发动机保养记录缺少保养照片`,
    //         };
    //       }
    //     }
    //   }

    //   // 校验变速器保养记录
    //   if (
    //     this.form.transmissionRecordList &&
    //     this.form.transmissionRecordList.length > 0
    //   ) {
    //     for (let i = 0; i < this.form.transmissionRecordList.length; i++) {
    //       const record = this.form.transmissionRecordList[i];
    //       if (!record.time) {
    //         return {
    //           valid: false,
    //           message: `第${i + 1}条变速器保养记录缺少保养时间`,
    //         };
    //       }
    //       if (
    //         record.mileage === "" ||
    //         record.mileage === null ||
    //         record.mileage === undefined
    //       ) {
    //         return {
    //           valid: false,
    //           message: `第${i + 1}条变速器保养记录缺少保养里程`,
    //         };
    //       }
    //       if (!record.photos || record.photos.length === 0) {
    //         return {
    //           valid: false,
    //           message: `第${i + 1}条变速器保养记录缺少保养照片`,
    //         };
    //       }
    //     }
    //   }

    //   return { valid: true };
    // },
  },
  mounted() {
    this.getTypeList();
  },
};
</script>

<style lang="scss" scoped>
// 保养记录样式
.maintenance-records {
  width: 100%;
  .record-item {
    border: 1px solid var(--line-color);
    border-radius: 4px;
    padding: 10px 15px;
    margin: 10px 0;
    position: relative;
    .remove-record {
      display: flex;
      align-items: center;
      justify-content: flex-end;
      margin-bottom: 10px;
    }
    .remove-record-btn {
      font-size: 12px !important;
      color: #666;
    }
  }
}
</style>
